import React from "react";
import { Modal } from "react-bootstrap";
import { ClipLoader } from "react-spinners";
import { IoIosInformationCircleOutline } from "react-icons/io";
import moment from "moment";

const UploadAndListingRelaunchModal = ({
  handleRelaunch,
  handleCloseRelaunchModal,
  relaunchModal,
  loading,
  relaunchData,
  setRelaunchData,
  errorMessageRelaunch,
  setErrorMessageRelaunch,
  currentDate,
}) => {
  return (
    <Modal
      show={relaunchModal}
      onHide={handleCloseRelaunchModal}
      backdrop="static"
      className="editproductModal"
    >
      <Modal.Header closeButton>
        <h4 className="modal-title common_heading">Relaunch</h4>
      </Modal.Header>
      <Modal.Body className="popup_body_scroll">
        <div className="row">
          <div className="col-lg-6 col-sm-4 col-12">
            <div className="form-group">
              <label className="required-label">
                MRP(₹)
                <span className="required">*</span>
                <button
                  type="button"
                  className="toottip_button"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title="MRP of the Product"
                  aria-describedby="tooltip"
                >
                  <IoIosInformationCircleOutline className="tooltip_icon_i" />
                </button>
              </label>

              <p className="Uploadzz mb-0">
                <input
                  type="number"
                  min="1"
                  className="form-control"
                  placeholder=""
                  value={relaunchData?.Mrp}
                  onChange={(e) => {
                    setRelaunchData({ ...relaunchData, Mrp: e?.target?.value });
                    setErrorMessageRelaunch({
                      ...errorMessageRelaunch,
                      Mrp: "",
                    });
                  }}
                />
              </p>
              {errorMessageRelaunch?.Mrp ? (
                <div className="validation-message">
                  {errorMessageRelaunch?.Mrp}
                </div>
              ) : null}
            </div>
          </div>

          <div className="col-lg-6 col-sm-4 col-12">
            <div className="form-group">
              <label>
                Brand Name
                <span className="required">*</span>
                <button
                  type="button"
                  className="toottip_button"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title="Brand Name of Your Product"
                  aria-describedby="tooltip"
                >
                  <IoIosInformationCircleOutline className="tooltip_icon_i" />
                </button>
              </label>

              <p className="Uploadzz mb-0">
                <input
                  type="text"
                  className="form-control"
                  placeholder=""
                  value={relaunchData?.BrandName}
                  onChange={(e) => {
                    setRelaunchData({
                      ...relaunchData,
                      BrandName: e?.target?.value,
                    });
                    setErrorMessageRelaunch({
                      ...errorMessageRelaunch,
                      BrandName: "",
                    });
                  }}
                />
              </p>
              {errorMessageRelaunch?.BrandName ? (
                <div className="validation-message">
                  {errorMessageRelaunch?.BrandName}
                </div>
              ) : null}
            </div>
          </div>

          <div className="col-lg-6 col-sm-4 col-12">
            <div className="form-group pro_option">
              <div className="w-100">
                <label className="required-label">
                  Product Options
                  <span className="required">*</span>
                  <button
                    type="button"
                    className="toottip_button"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-title="What your product has to offer to final consumer"
                    aria-describedby="tooltip"
                  >
                    <IoIosInformationCircleOutline className="tooltip_icon_i" />
                  </button>
                </label>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="form-check form-check-inline">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="IsProductInOffer"
                      checked={relaunchData?.IsProductInOffer === "bid"}
                      onChange={() => {
                        setRelaunchData({
                          ...relaunchData,
                          IsProductInOffer: "bid",
                        });
                        setErrorMessageRelaunch({
                          ...errorMessageRelaunch,
                          IsProductInOffer: "",
                        });
                      }}
                    />
                    <label>
                      Add To Offer
                      <button
                        type="button"
                        className="toottip_button"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-title="User can bid the product to get free"
                        aria-describedby="tooltip"
                      >
                        <IoIosInformationCircleOutline className="tooltip_icon_i" />
                      </button>
                    </label>
                  </div>
                </div>
                <div className="form-check form-check-inline">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="IsProductInOffer"
                      checked={relaunchData?.IsProductInOffer == "buy"}
                      onChange={() => {
                        setRelaunchData({
                          ...relaunchData,
                          IsProductInOffer: "buy",
                        });
                        setErrorMessageRelaunch({
                          ...errorMessageRelaunch,
                          IsProductInOffer: "",
                        });
                      }}
                    />
                    <label>
                      Add To Buy
                      <button
                        type="button"
                        className="toottip_button"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-title="Product buy button will be available for the product"
                        aria-describedby="tooltip"
                      >
                        <IoIosInformationCircleOutline className="tooltip_icon_i" />
                      </button>
                    </label>
                  </div>
                </div>
                <div className="form-check form-check-inline">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="IsProductInOffer"
                      checked={relaunchData?.IsProductInOffer === "contact"}
                      onChange={() => {
                        setRelaunchData({
                          ...relaunchData,
                          IsProductInOffer: "contact",
                        });
                        setErrorMessageRelaunch({
                          ...errorMessageRelaunch,
                          IsProductInOffer: "",
                        });
                      }}
                    />
                    <label>
                      Get in Touch
                      <button
                        type="button"
                        className="toottip_button"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-title="Contact us button will be available for the product"
                        aria-describedby="tooltip"
                      >
                        <IoIosInformationCircleOutline className="tooltip_icon_i" />
                      </button>
                    </label>
                  </div>
                </div>
              </div>

              {errorMessageRelaunch?.IsProductInOffer ? (
                <div className="validation-message">
                  {errorMessageRelaunch?.IsProductInOffer}
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-lg-6 col-sm-4 col-12">
            <div className="form-group">
              <label className="required-label">
                Relaunch For Previous Bidder?
              </label>
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <input
                    type="radio"
                    id="yes"
                    name="IsRelauchForPreviousUsers"
                    checked={relaunchData?.IsRelauchForPreviousUsers==true}

                    onClick={() =>
                      setRelaunchData({
                        ...relaunchData,
                        IsRelauchForPreviousUsers: true,
                      })
                    }
                  />
                  <label for="yes">Yes</label>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <input
                    type="radio"
                    id="no"
                    name="IsRelauchForPreviousUsers"
                    onClick={() =>
                        setRelaunchData({
                          ...relaunchData,
                          IsRelauchForPreviousUsers: false,
                        })
                      }
                  />
                  <label for="no">No</label>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-sm-4 col-12">
            <div className="form-group">
              <label>
                Deal Price(₹)
                <button
                  type="button"
                  className="toottip_button"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title="Discounted price ( 0 If Product is in offer )"
                  aria-describedby="tooltip"
                >
                  <IoIosInformationCircleOutline className="tooltip_icon_i" />
                </button>
              </label>

              <p className="Uploadzz mb-0">
                <input
                  type="number"
                  min="1"
                  className="form-control"
                  placeholder=""
                  value={relaunchData?.DealPrice}
                  onChange={(e) =>
                    setRelaunchData({
                      ...relaunchData,
                      DealPrice: e?.target?.value,
                    })
                  }
                />
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-sm-4 col-12">
            <div className="form-group">
              <label className="required-label">
                Quantity
                <span className="required">*</span>
                <button
                  type="button"
                  className="toottip_button"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title="Number of product you have to sell"
                  aria-describedby="tooltip"
                >
                  <IoIosInformationCircleOutline className="tooltip_icon_i" />
                </button>
              </label>

              <p className="Uploadzz mb-0">
                <input
                  type="number"
                  className="form-control"
                  placeholder=""
                  value={relaunchData?.Quantity}
                  onChange={(e) => {
                    setRelaunchData({
                      ...relaunchData,
                      Quantity: e?.target?.value,
                    });
                    setErrorMessageRelaunch({
                      ...errorMessageRelaunch,
                      Quantity: "",
                    });
                  }}
                />
              </p>
              {errorMessageRelaunch?.Quantity ? (
                <div className="validation-message">
                  {errorMessageRelaunch?.Quantity}
                </div>
              ) : null}
            </div>
          </div>
          {relaunchData?.IsProductInOffer === "bid" ? (
            <div className="col-lg-6 col-sm-4 col-12">
              <div className="form-group">
                <label>
                  Recommended Points
                  <button
                    type="button"
                    className="toottip_button"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-title="Recommeded bid point for the customer"
                    aria-describedby="tooltip"
                  >
                    <IoIosInformationCircleOutline className="tooltip_icon_i" />
                  </button>
                </label>

                <p className="Uploadzz mb-0">
                  <input
                    type="number"
                    className="form-control"
                    min="1"
                    placeholder="Points"
                    value={relaunchData?.RecommendedBid}
                    onChange={(e) => {
                      setRelaunchData({
                        ...relaunchData,
                        RecommendedBid: e?.target?.value,
                      });
                      setErrorMessageRelaunch({
                        ...errorMessageRelaunch,
                        RecommendedBid: "",
                      });
                    }}
                  />
                </p>
              </div>
              {errorMessageRelaunch?.RecommendedBid ? (
                <div className="validation-message">
                  {errorMessageRelaunch?.RecommendedBid}
                </div>
              ) : null}
            </div>
          ) : null}
          <div className="col-lg-6 col-sm-4 col-12">
            <div className="form-group">
              <label for="appt" className="required-label">
                From Publish Date
                <span className="required">*</span>
                <button
                  type="button"
                  className="toottip_button"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title="Date from when your product will get published"
                  aria-describedby="tooltip"
                >
                  <IoIosInformationCircleOutline className="tooltip_icon_i" />
                </button>
              </label>

              <p className="Uploadzz mb-0">
                <input
                  type="date"
                  className="form-control"
                  placeholder="Publish Date"
                  min={currentDate}
                  value={
                    moment(relaunchData.FromPublishDate).format("YYYY-MM-DD") ||
                    ""
                  }
                  onChange={(e) => {
                    setRelaunchData({
                      ...relaunchData,
                      FromPublishDate: moment(e?.target?.value).format(
                        "YYYY-MM-DDT00:00:00"
                      ),
                    });
                    setErrorMessageRelaunch({
                      ...errorMessageRelaunch,
                      FromPublishDate: "",
                    });
                  }}
                />
              </p>
              {errorMessageRelaunch?.FromPublishDate ? (
                <div className="validation-message">
                  {errorMessageRelaunch?.FromPublishDate}
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-lg-6 col-sm-4 col-12">
            <div className="form-group">
              <label for="appt" className="required-label">
                To Publish Date
                <span className="required">*</span>
                <button
                  type="button"
                  className="toottip_button"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title="Your product last date"
                  aria-describedby="tooltip"
                >
                  <IoIosInformationCircleOutline className="tooltip_icon_i" />
                </button>
              </label>

              <p className="Uploadzz mb-0">
                <input
                  type="date"
                  className="form-control"
                  placeholder="Publish Date"
                  min={moment(relaunchData.FromPublishDate).format(
                    "YYYY-MM-DD"
                  )}
                  disabled={!relaunchData?.FromPublishDate}
                  value={
                    moment(relaunchData.ToPublishDate).format("YYYY-MM-DD") ||
                    ""
                  }
                  onChange={(e) => {
                    setRelaunchData({
                      ...relaunchData,
                      ToPublishDate: moment(e?.target?.value).format(
                        "YYYY-MM-DDT00:00:00"
                      ),
                    });
                    setErrorMessageRelaunch({
                      ...errorMessageRelaunch,
                      ToPublishDate: "",
                    });
                  }}
                />
              </p>
              {errorMessageRelaunch?.ToPublishDate ? (
                <div className="validation-message">
                  {errorMessageRelaunch?.ToPublishDate}
                </div>
              ) : null}
            </div>
          </div>

          <div className="col-lg-6 col-sm-4 col-12">
            <div className="form-group">
              <label for="appt" className="required-label">
                Select a Expiring Time of Item
                <span className="required">*</span>
                <button
                  type="button"
                  className="toottip_button"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title="Your product will expire at this time"
                  aria-describedby="tooltip"
                >
                  <IoIosInformationCircleOutline className="tooltip_icon_i" />
                </button>
              </label>

              <input
                type="time"
                className="form-control"
                value={
                  relaunchData.ProductExpiringTime
                    ? moment(
                        relaunchData.ProductExpiringTime.split("T")[0] +
                          "T" +
                          relaunchData.ProductExpiringTime.split("T")[1].slice(
                            0,
                            5
                          )
                      ).format("HH:mm")
                    : ""
                }
                onChange={(e) => {
                  const selectedTime = e?.target?.value;
                  if (relaunchData.ToPublishDate && selectedTime) {
                    const formattedDateTime = `${
                      relaunchData.ToPublishDate.split("T")[0]
                    }T${selectedTime}`;
                    setRelaunchData({
                      ...relaunchData,
                      ProductExpiringTime: formattedDateTime,
                    });
                  }
                  setErrorMessageRelaunch({
                    ...errorMessageRelaunch,
                    ProductExpiringTime: "",
                  });
                }}
              />
              {errorMessageRelaunch?.ProductExpiringTime ? (
                <div className="validation-message">
                  {errorMessageRelaunch?.ProductExpiringTime}
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-lg-6 col-sm-4 col-12">
            <div className="form-group">
              <label for="combinedDateTime">
                Product Expire At
                <button
                  type="button"
                  className="toottip_button"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title="Product expiring Date and Time ( Winner will be Declare 1 minute after if product is in offer)"
                  aria-describedby="tooltip"
                >
                  <IoIosInformationCircleOutline className="tooltip_icon_i" />
                </button>
              </label>

              <input
                type="datetime-local"
                className="form-control"
                readonly
                disabled
                value={
                  relaunchData.ToPublishDate && relaunchData.ProductExpiringTime
                    ? moment(
                        relaunchData.ProductExpiringTime.split("T")[0] +
                          "T" +
                          relaunchData.ProductExpiringTime.split("T")[1].slice(
                            0,
                            5
                          )
                      ).format("YYYY-MM-DDTHH:mm")
                    : ""
                }
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="common_btn btn-secondary"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>
        {loading == "updateBanner" ? (
          <button type="button" className="common_btn view-data-btn">
            <ClipLoader className="main_loader_home" loading size={15} />{" "}
          </button>
        ) : (
          <button
            type="button"
            className="common_btn view-data-btn"
            onClick={handleRelaunch}
          >
            Relaunch
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default UploadAndListingRelaunchModal;
